import { constructionSafety, logisticsAsset, manufacturingAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import video from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

export default {
  desc: 'Để xây dựng một công trường xây dựng an toàn, việc nắm bắt tình hình an toàn của người lao động theo thời gian thực, phòng ngừa tai nạn và đối phó nhanh chóng khi có sự cố xảy ra là điều bắt buộc.',
  keywords:
    'Luật xử phạt tai nạn nghiêm trọng, an toàn lao động, công trường xây dựng, RTLS, luat xu phat tai nan nghiem trong, an toan lao dong, cong truong xay dung, rtls.',
  ogSite: 'Giải pháp phòng ngừa theo Luật Xử phạt Tai nạn Nghiêm trọng: Quản lý an toàn công trường xây dựng (luật Hàn Quốc)',
  title: 'Giải pháp phòng ngừa theo Luật Xử phạt Tai nạn Nghiêm trọng: Quản lý an toàn công trường xây dựng (luật Hàn Quốc)',
  ogUrl: 'https://orbro.io/vi/blog/construction-solution',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AK0iWDxcFbqyCgsLqX77SjZSbmhPyHShDbN57Y0uVQssyTRIySb5QaO86GwRQU2XDIM6wENVOKG_sn4SuK6BIHu6D3_n9v4DTFhHsRRVUg7UmWsG9qrjE9rGDPe6P0_Ox2um950sgEHtj-KLjzqld-ZdzNkaE9QjgTMEVmj2tkQ1pPVRozYUD-xIl94PQaGNp7tQuO1Hob1FvMuSLLEcdXdUxZmR9CoCl4ArjWfuuwr1d6lvN2umbSY0_y7mc8jTFyCu9Dk5Wi_v3aDRSH29LhUBlpZyeEyM5oCecT8fbW04YC3xCmuCmG41FwPtKf2akaJlFuBsSXINWwYzKejipOUhx5BayplcpMLZKsJoGI_6BI4RTrNIGGFpS4LZqAmgN3JWX43wftmGOlcwJ2np2WFszY2X5QqQdeAdnTXKLzgiYRCcjrM0cHzvzsLebg0KbpyAgCiLawwttYXLmqYEUsw-7it4OWqarLHXZxq4K2hggeMrpWJVFc6R84ruA7y4WPP4lNxVTbcGz3h0tcwGbYv8mGEc5UjMsDalMc8fOmsS5_Dy9qrOewKS-A4oZsW0bBJ1IYnhhHgCvKL4VP19n_PzOnu51vLF_B2xWmnR6pT5F3wa7GapNjG0QEN3185QO4AI9hysQXwb4wLEZqT5dGeHzwRvfIfrp_NCJ6xUbTHt3W070iXbqCG-7liIoaYzwbWYUA_U21h4elbMhPdZqvaIJBQRWBRRKxo8RdjyguhL-3b3LSOd4ffx3PJuvI6T7d5Q89IwZccvi2VLTR2Z5XiTUAveb8J_U3zPTKmIliM2rNcFCQ2zUW61y3Je0voWlaxLRy-_eHoH-tLuixemebIJo770TZZk69mhoNcuzZf0HepRpMoZ_gK7WX5gZ9ybogR9JvNsEQ6do078xyLvTKuZQpri86vobe9PvXeTkVM-_h6agSAcUfUihK0GLiehcw4MjrNaXaq-eqEEEf_aWtfPJAjuJ7JXtFXOiuO6hBMA1-qPq6e_VOOcRJl3PigwW66TzDYgjowTnaD7M1dWDXFYFz_OJS0u8UQbmeKd1TT5h30l70YXeabd4BvtI33YLCL_fJ2ReOIzwUmzZZiEBplwIAxzDcNPvmVwfd5YzvxVGdtm3WEBbzZR0q-MdVvbABRxn90yZ7U2vcwgvNbSTJbC5aWQyI7Jd6LiooIa8nWVkVwaMK_vOmDwotOk2vnamSORh837qPfvlDmUuBX7RRN19heNUGbFF20032J3_JRYcT3AA8eYmTV8LKhQuF0eNQAUe40lPKPGrdrnDHBsjBdHgoOxOHd-ChckYyCFOL3a-FpQv4OO_OpXL6lWWv4SwJsdzXxWT0h2uqoGu0ONpkDv7O3WiZF4E3cQ46IlBsU_K4JWsh1R9pjjLBSRy61vgbvfD4a7yzwU-qvZ6sd5wm6HyVVOU4pmgYoH1SG86ZISmHsUXYxdrWo4vuJDA1If2gUg6P7Y7uMooHmA2MlFPgVsT3xqakmYR-xx3Z3gZnIbcFzO7LldLuSvs8Ha8nMoI9HM2dh6uxK5_9OTfmQRIGHTZngWgCBZrRIz4ARaIxBZiw=w2249-h1298',
  ogType: 'website',
  date: '2023-12-11',
  tag1: '#Luatxuphattainanghiemtrong',
  tag2: '#Antoanlaodong',
  tag3: '#Congtruongxaydung',
  tag4: '#Rtls',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Để xây dựng một công trường xây dựng an toàn, việc nắm bắt tình hình an toàn của người lao động theo thời gian thực, phòng ngừa tai nạn và đối phó nhanh chóng khi có sự cố xảy ra là điều bắt buộc. Đặc biệt, xét đến Luật Xử phạt Tai nạn Nghiêm trọng, việc sử dụng hiệu quả ‘công nghệ theo dõi vị trí thời gian thực’ (RTLS) như một công cụ then chốt để giảm thiểu tai nạn lao động là rất quan trọng.',
      dot: '',
    },
    {
      head: '1. Các chức năng cốt lõi của công nghệ theo dõi vị trí thời gian thực',
      subHead: 'Xác định vị trí chính xác',
      desc: 'Công nghệ RTLS sử dụng GPS, RFID, UWB, v.v., để theo dõi vị trí chính xác của người lao động trên công trường xây dựng theo thời gian thực. Thông qua đó, tạo dựng một môi trường làm việc an toàn và xác định trước các khu vực nguy hiểm.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giám sát an toàn người lao động',
      desc: 'Dựa trên dữ liệu vị trí, hệ thống giám sát chuyển động của người lao động để kiểm tra tình trạng an toàn trong quá trình làm việc theo thời gian thực. Có thể nhanh chóng phát hiện các tình huống hoặc khu vực nguy hiểm để đưa ra biện pháp xử lý phù hợp.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giám sát thiết bị nặng',
      desc: 'Không chỉ người lao động, vị trí của các thiết bị nặng và vật tư cũng được xác định theo thời gian thực để nắm bắt tình hình hiện trường. Nhờ đó, có thể kiểm soát và quản lý tình hình hiện trường một cách an toàn hơn bằng cách xác định các nguy cơ va chạm với người lao động hoặc việc tiếp cận khu vực nguy hiểm.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Đối phó nhanh chóng khi xảy ra tai nạn',
      desc: 'Khi có tai nạn xảy ra, hệ thống RTLS nhanh chóng xác định vị trí liên quan và nắm bắt nội dung vụ việc, cho phép đối phó kịp thời. Có thể ứng phó hiệu quả trong các tình huống khẩn cấp.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Thu thập và phân tích dữ liệu',
      desc: 'Bằng cách thu thập và phân tích dữ liệu vị trí, có thể xác định các mô hình làm việc và khu vực nguy hiểm tại công trường xây dựng. Điều này góp phần vào các biện pháp phòng ngừa và cải thiện chính sách an toàn.',
      dot: '',
    },
    {
      head: '2. Ưu điểm',
      subHead: 'Tăng cường tính an toàn',
      desc: 'RTLS tăng cường tính an toàn thông qua việc xác định chính xác vị trí của người lao động. Thông qua việc đối phó nhanh chóng khi xảy ra tai nạn, đảm bảo tuân thủ Luật Xử phạt Tai nạn Nghiêm trọng và an toàn cho người lao động.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Nâng cao năng suất',
      desc: 'Sử dụng thông tin vị trí chính xác để bố trí người lao động hiệu quả và lập kế hoạch công việc, qua đó tối ưu hóa quy trình xây dựng và nâng cao năng suất.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giảm thiểu chi phí',
      desc: 'Giảm thiểu tổn thất phát sinh do phòng ngừa tai nạn và đối phó nhanh chóng, đồng thời mang lại hiệu quả giảm chi phí nhờ nâng cao năng suất.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý tài nguyên hiệu quả',
      desc: 'Thông qua RTLS, quản lý hiệu quả các tài nguyên trong công trường xây dựng, giảm thiểu lãng phí tài nguyên không cần thiết và cho phép vận hành hiệu quả.\nCông nghệ RTLS, với mục tiêu giảm thiểu tai nạn lao động và cải thiện môi trường làm việc, đang đóng một vai trò ngày càng thiết yếu trong ngành xây dựng. Thông qua đó, nó sẽ giúp ích rất nhiều trong việc nâng cao tính an toàn và hiệu quả tại các công trường xây dựng.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.key1,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
      {
        img: manufacturingAsset.thumb,
        data: 'manufacturingAsset',
        link: '/vi/enterprise/manufacturing/asset',
      },
    ],
  },
};
